<div class="flex-row align-center cursor-pointer" [routerLink]="['']">
  <df-shared-lib-logo class="flex-row align-center" [widthLogo]="30"></df-shared-lib-logo>
  <span style="margin-top: auto; margin-left: 5px;" class="df-logo-text bold">Danceflavors</span>
</div>
